import t from "./index875.js";
import i from "./index802.js";
var s = Object.prototype, p = s.hasOwnProperty;
function l(r, a, o) {
  var n = r[a];
  (!(p.call(r, a) && i(n, o)) || o === void 0 && !(a in r)) && t(r, a, o);
}
export {
  l as default
};
